import './component.scss'
import 'Images/refosumu/subsidies/refosumu_floating_icon.svg'
import 'Images/refosumu/subsidies/right_diagonal_upper_line.svg'
import 'Images/refosumu/subsidies/right_diagonal_lower_line.svg'

const SCROLL_THRESHOLD = 300
const TRANSITION_DURATION = 600
const DISPLAY_DELAY = 20
const MAX_SP_WIDTH = 999

document.addEventListener('DOMContentLoaded', () => {
  const floatingElement = document.querySelector('.refosumu-v2-subsidies-floating-cta-sp')
  const floatingState = {
    isVisible: false,
    isAnimating: false
  }

  const handleScroll = () => {
    if (window.innerWidth > MAX_SP_WIDTH) {
      hideElementImmediately(floatingElement, floatingState)
      return
    }

    const shouldBeVisible = window.scrollY > SCROLL_THRESHOLD

    // 状態変更があり、アニメーション中でない場合のみ処理
    if (shouldBeVisible === floatingState.isVisible || floatingState.isAnimating) return

    shouldBeVisible ? showElement(floatingElement, floatingState) : hideElement(floatingElement, floatingState)
  }

  const handleResize = () => {
    // PCサイズの場合は即座に非表示
    if (window.innerWidth >= MAX_SP_WIDTH) {
      hideElementImmediately(floatingElement, floatingState)
      return
    }

    // SPサイズで閾値を超えている場合のみ表示
    if (window.scrollY > SCROLL_THRESHOLD && !floatingState.isVisible && !floatingState.isAnimating) {
      showElement(floatingElement, floatingState)
    }
  }

  const initializeState = () => {
    // PCサイズまたは閾値以下の場合は表示しない
    if (window.innerWidth > MAX_SP_WIDTH || window.scrollY <= SCROLL_THRESHOLD) {
      floatingElement.style.display = 'none'
      return
    }

    // SPサイズで閾値を超えている場合は表示
    floatingElement.style.display = 'block'
    floatingElement.style.opacity = '1'
    floatingState.isVisible = true
  }

  initializeState()
  window.addEventListener('scroll', handleScroll)
  window.addEventListener('resize', handleResize)
})

const showElement = (element, floatingState) => {
  if (floatingState.isAnimating || floatingState.isVisible) return

  floatingState.isAnimating = true
  element.style.display = 'block'

  // 少しの遅延を入れてdisplayプロパティの適用を確実にする
  setTimeout(() => {
    element.style.opacity = '1'

    // フェードイン完了後に状態を更新
    setTimeout(() => {
      floatingState.isVisible = true
      floatingState.isAnimating = false
    }, TRANSITION_DURATION)
  }, DISPLAY_DELAY)
}

const hideElement = (element, floatingState) => {
  if (floatingState.isAnimating || !floatingState.isVisible) return

  floatingState.isAnimating = true
  element.style.opacity = '0'

  // フェードアウト完了後に要素を非表示にする
  setTimeout(() => {
    element.style.display = 'none'
    floatingState.isVisible = false
    floatingState.isAnimating = false
  }, TRANSITION_DURATION)
}

const hideElementImmediately = (element, floatingState) => {
  if (element.style.display !== 'none') {
    element.style.opacity = '0'
    element.style.display = 'none'
    floatingState.isVisible = false
  }
}
